import { PersonDetailsReactionsResponse } from 'app/components/DetailsPages/hooks/person/usePersonDetailsLikes';
import {
  IPersonDetailsCommonGroundResponse,
  IPersonDetailsCommunitiesResponse,
  IPersonDetailsConveningsResponse,
  IPersonDetailsHumanAtAGlanceResponse,
  IPersonDetailsPassionsResponse,
  IPersonDetailsProfessionalAtAGlanceResponse,
  IPersonDetailsProjectsResponse,
  IPersonDetailsResponse,
  IPersonDetailsSkillsResponse,
  IPersonDetailsStoriesAndHighlightsResponse,
} from 'app/components/DetailsPages/interfaces/person';

import { http } from './http';

export const getPersonDetails = (slug: string) => {
  return http.get<IPersonDetailsResponse>(`person/${slug}/details`);
};

export const getPersonDetailsHumanAtAGlance = (slug: string) => {
  return http.get<IPersonDetailsHumanAtAGlanceResponse>(`person/${slug}/details/human_at_a_glance`);
};

export const getPersonDetailsProfessionalAtAGlance = (slug: string) => {
  return http.get<IPersonDetailsProfessionalAtAGlanceResponse>(
    `person/${slug}/details/professional_at_a_glance`
  );
};

export const getPersonDetailsPassions = (slug: string) => {
  return http.get<IPersonDetailsPassionsResponse>(`person/${slug}/details/passions`);
};

export const getPersonDetailsSkills = (slug: string) => {
  return http.get<IPersonDetailsSkillsResponse>(`person/${slug}/details/skills`);
};

export const getPersonDetailsProjects = (slug: string) => {
  return http.get<IPersonDetailsProjectsResponse>(`person/${slug}/details/projects`);
};

export const getPersonDetailsConvenings = (slug: string) => {
  return http.get<IPersonDetailsConveningsResponse>(`person/${slug}/details/convenings`);
};

export const getPersonDetailsCommunities = (slug: string) => {
  return http.get<IPersonDetailsCommunitiesResponse>(`person/${slug}/details/communities`);
};

export const getPersonDetailsStoriesAndHighlights = (slug: string) => {
  return http.get<IPersonDetailsStoriesAndHighlightsResponse>(
    `person/${slug}/details/stories_and_highlights`
  );
};

export const getPersonDetailsCommonGround = (slug: string) => {
  return http.get<IPersonDetailsCommonGroundResponse>(`person/${slug}/details/common_ground`);
};

export const getPersonDetailsLikes = (slug: string) => {
  return http.get<PersonDetailsReactionsResponse>(`reactions/person`, { uuid: slug });
};

export const getPersonDetailsLikesDrawer = (slug: string) => {
  return http.get<PersonDetailsReactionsResponse>(`reactions/drawer`, { uuid: slug });
};

//DRAWERS
export const getPersonDetailsClientsDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/clients`);
};

export const getPersonDetailsLanguagesDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/languages`);
};

export const getPersonDetailsPassionsDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/passions`);
};

export const getPersonDetailsCommonGroundDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/common_ground`);
};

export const getPersonDetailsIndustriesDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/industries`);
};

export const getPersonDetailsProjectsDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/projects`);
};

export const getPersonDetailsSkillsDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/skills`);
};

export const getPersonDetailsLocationsDrawer = (slug: string) => {
  return http.get<any>(`person/${slug}/drawers/locations`);
};
